export { default as IconCategoryOthers } from './iconCategoryOthers';
export { default as IconCategoryAll } from './iconCategoryAll';
export { default as IconCategoryBusiness } from './iconCategoryBusiness';
export { default as IconCategoryLearn } from './iconCategoryLearn';
export { default as IconCategoryFood } from './iconCategoryFood';
export { default as IconCategoryPride } from './iconCategoryPride';
export { default as IconCategoryKid } from './iconCategoryKid';
export { default as IconCategoryGamesGeek } from './iconCategoryGamesGeek';
export { default as IconCategoryTheater } from './iconCategoryTheater';
export { default as IconCategoryFashion } from './iconCategoryFashion';
export { default as IconCategoryReligious } from './iconCategoryReligious';
export { default as IconCategoryHealth } from './iconCategoryHealth';
export { default as IconCategoryParty } from './iconCategoryParty';
export { default as IconCategorySport } from './iconCategorySport';
export { default as IconCategoryTec } from './iconCategoryTec';
export { default as IconCategoryPremium } from './iconCategoryPremium';
